export default __webpack_public_path__ + "static/media/img1.4e2e6d5b.PNG";